(function () {
  if (window.BadeloftConfiguratorBridge) return;
  window.BadeloftConfiguratorBridge = true;

  var BATHTUB_SWATCHES = {
    white: { matte: 'bf-swatch-matte-white.png', glossy: 'bf-swatch-glossy-white.png' },
    black: { matte: 'bf-swatch-black-matte.png', glossy: 'bf-swatch-black-glossy.png' },
    grey: { matte: 'bf-swatch-grey-matte.png', glossy: 'bf-swatch-grey-glossy.png' },
  };

  var DRAIN_CAP_PRESETS = {
    chrome: 'chrome',
    'brushed steel': 'brushed_nickel',
    'brushed nickel': 'brushed_nickel',
    'brushed gold': 'brushed_gold',
    gold: 'brushed_gold',
    'rose gold': 'brushed_rose_gold',
    'brushed rose gold': 'brushed_rose_gold',
    'matte white': 'matte_white',
    'matte black': 'matte_black',
    'matte grey': 'matte_grey',
    'matte gray': 'matte_grey',
  };

  var COLOUR_LABELS = { white: 'White', black: 'Black', grey: 'Grey' };
  var FINISH_LABELS = { matte: 'Matte', glossy: 'Glossy' };

  function is3dActive() {
    return !!document.querySelector('[data-bf-3d-configurator]');
  }

  function canApply3dChanges() {
    var mount = getMount();
    if (!mount || !mount.classList.contains('is-ready')) return false;
    // Tour lives in its own tab panel — keep it interactive for 3D-only controls.
    if (mount.closest('[data-bf-panel="tour3d"]')) return true;

    var productInfo = document.querySelector('.product-information[data-bf-3d-hybrid-product]');
    if (!productInfo) return true;
    return productInfo.classList.contains('bf-3d-media-active');
  }

  /** True when the event originated from the 3D Tour material / dock UI. */
  function isEventFrom3dTourUi(event) {
    var target = event && event.target;
    if (!(target instanceof Element)) return false;
    return !!(
      target.closest('[data-bf-3d-material-panel]') ||
      target.closest('[data-bf-3d-configurator]') ||
      target.closest('.bf-3d-configurator__dock')
    );
  }

  function isMountInteractive(mount) {
    if (!mount) return false;
    var panel = mount.closest('.bf-tabs__panel');
    if (panel && !panel.classList.contains('is-active')) return false;
    return mount.getClientRects().length > 0;
  }

  function getMount() {
    var mounts = document.querySelectorAll('[data-bf-3d-configurator]');
    if (!mounts.length) return null;

    for (var i = 0; i < mounts.length; i++) {
      if (isMountInteractive(mounts[i])) return mounts[i];
    }

    return mounts[0];
  }

  function getConfig() {
    var mount = getMount();
    if (!mount) return null;

    var node = mount.querySelector('[data-bf-3d-config]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function getFinishKey(input) {
    var value = input && input.value ? input.value.toLowerCase() : '';
    return value.indexOf('glossy') > -1 ? 'glossy' : 'matte';
  }

  function getCheckedFinishInput() {
    return document.querySelector('.bf-cfg__row--finish input[data-variant-id]:checked');
  }

  function getVariantKey(colour, finish) {
    return colour + '_' + finish;
  }

  function resolveVariantId(colour, finish) {
    var config = getConfig();
    if (config && config.variants) {
      var mapped = config.variants[getVariantKey(colour, finish)];
      if (mapped) return mapped;
    }

    var tile =
      document.querySelector('[data-bf-colour-tile][data-colour="' + colour + '"]') ||
      document.querySelector('[data-bf-colour-btn][data-colour="' + colour + '"]');
    if (!tile) return null;

    if (finish === 'glossy') {
      return tile.getAttribute('data-glossy-variant') || null;
    }
    return tile.getAttribute('data-matte-variant') || null;
  }

  function updateMountState(colour, finish) {
    var mount = getMount();
    if (!mount) return;
    mount.dataset.currentColour = colour;
    mount.dataset.currentFinish = finish;
  }

  function getSwatchAssetBase(panel) {
    if (!panel) return null;

    var samples = panel.querySelectorAll(
      '[data-bf-3d-bathtub-colour], [data-bf-3d-bathtub-finish], [data-bf-3d-sink-colour], [data-bf-3d-sink-finish], [data-bf-3d-slot="drainCap"], [data-bf-3d-slot="faucet"]'
    );
    for (var i = 0; i < samples.length; i += 1) {
      var bg = samples[i].style.backgroundImage || '';
      var match = bg.match(/url\(["']?([^"')]+)/);
      if (!match) continue;
      return match[1].replace(/bf-swatch-[^/]+\.png.*$/, '');
    }
    return null;
  }

  function updateBathtubSwatches(colour, finish) {
    var panel = document.querySelector('[data-bf-3d-material-panel]');
    if (!panel) return;

    var swatchSet = BATHTUB_SWATCHES[colour];
    if (!swatchSet) return;

    var assetBase = getSwatchAssetBase(panel);
    if (!assetBase) return;

    var colourLabel = COLOUR_LABELS[colour] || colour;
    var finishLabel = FINISH_LABELS[finish] || 'Matte';

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-bathtub-colour]'), function (btn) {
      var key = btn.getAttribute('data-bf-3d-bathtub-colour');
      var set = BATHTUB_SWATCHES[key];
      if (!set) return;
      btn.style.backgroundImage = 'url(' + assetBase + set[finish] + ')';
    });

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-bathtub-finish]'), function (btn) {
      var key = btn.getAttribute('data-bf-3d-bathtub-finish');
      if (!swatchSet[key]) return;

      var label = (FINISH_LABELS[key] || key) + ' ' + colourLabel;
      btn.style.backgroundImage = 'url(' + assetBase + swatchSet[key] + ')';
      btn.setAttribute('data-bf-3d-label', label);
      btn.title = label;
      btn.setAttribute('aria-label', label);
    });

    updateBathtubPanelLabel(colour, finish);
  }

  function setActiveColourTile(colour) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-bf-colour-tile], [data-bf-colour-btn], [data-bf-3d-bathtub-colour]'),
      function (tile) {
        var tileColour =
          tile.getAttribute('data-colour') || tile.getAttribute('data-bf-3d-bathtub-colour');
        var isActive = tileColour === colour;
        tile.classList.toggle('is-active', isActive);
        if (isActive) {
          tile.setAttribute('aria-current', 'true');
        } else {
          tile.removeAttribute('aria-current');
        }
      }
    );
  }

  function syncNativeFinishSelection(colour, finish) {
    var colourLabel = COLOUR_LABELS[colour] || colour;
    var finishLabel = FINISH_LABELS[finish] || 'Matte';
    var targets = [
      finishLabel + ' ' + colourLabel,
      colourLabel + ' ' + finishLabel,
    ].map(function (value) {
      return value.toLowerCase();
    });

    var inputs = document.querySelectorAll('.bf-cfg__row--finish input[data-variant-id]');
    var matched = null;

    Array.prototype.forEach.call(inputs, function (input) {
      var value = (input.value || '').toLowerCase().trim();
      if (targets.indexOf(value) > -1) matched = input;
    });

    if (!matched || matched.checked) return;

    matched.checked = true;
    matched.dispatchEvent(new Event('change', { bubbles: true }));

    var valueEl = document.querySelector('[data-bf-finish-value]');
    if (valueEl) valueEl.textContent = matched.value;
  }

  function syncDrainCapPanel(presetKey, label) {
    var panel = document.querySelector('[data-bf-3d-material-panel]');
    if (!panel || !presetKey) return;

    var btn = panel.querySelector('[data-bf-3d-slot="drainCap"][data-bf-3d-preset="' + presetKey + '"]');
    if (btn) setActiveInGroup(btn);
    if (label) updateSlotLabel('drainCap', label);
  }

  function update3dColourLabel(colour) {
    document.querySelectorAll('[data-bf-3d-colour-label]').forEach(function (node) {
      node.textContent = COLOUR_LABELS[colour] || colour;
    });

    document.querySelectorAll('.bf-cfg__row').forEach(function (row) {
      var label = row.querySelector('.bf-cfg__label');
      if (!label || label.textContent.trim().toLowerCase() !== 'colour') return;
      var value = row.querySelector('.bf-cfg__value');
      if (value) value.textContent = COLOUR_LABELS[colour] || colour;
    });
  }

  function updateBathtubPanelLabel(colour, finish) {
    document.querySelectorAll('[data-bf-3d-slot-label="bathtub"]').forEach(function (label) {
      label.textContent =
        (FINISH_LABELS[finish] || 'Matte') + ' ' + (COLOUR_LABELS[colour] || colour);
    });
  }

  function setActiveInGroup(button) {
    var group = button.closest('.bf-cfg__tiles, .bf-sink-options__swatches, .bf-sink-options__chips, .bf-scene-style__swatches, .bf-scene-style__chips, .bf-3d-viewer-views__buttons') || button.parentElement;
    if (!group) return;
    Array.prototype.forEach.call(
      group.querySelectorAll(
        '.bf-cfg__3d-tile, .bf-cfg__chip, .bf-cfg__option, .bf-sink-options__swatch, .bf-sink-options__chip, .bf-scene-style__swatch, .bf-scene-style__chip, .bf-3d-viewer-views__btn, [data-bf-3d-slot], [data-bf-3d-sink-colour], [data-bf-3d-sink-finish], [data-bf-3d-camera-preset], [data-bf-3d-visibility], [data-bf-3d-faucet-style], [data-bf-3d-vanity-power]'
      ),
      function (tile) {
        tile.classList.remove('is-active');
      }
    );
    button.classList.add('is-active');
  }

  function updateSlotLabel(slotId, label) {
    if (!label) return;
    document.querySelectorAll('[data-bf-3d-slot-label="' + slotId + '"]').forEach(function (node) {
      node.textContent = label;
    });
  }

  function updateVariantInput(variantId) {
    if (!variantId) return;

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="id"]');
      if (input) input.value = variantId;
    });

    var sticky = document.querySelector('sticky-add-to-cart');
    if (sticky) sticky.setAttribute('data-current-variant-id', variantId);
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function updatePriceDisplay(variantId) {
    var config = getConfig();
    if (!config || !config.variantDetails) return;

    var details = config.variantDetails[String(variantId)];
    if (!details) return;

    var priceNodes = document.querySelectorAll('[data-product-price], .price .money, product-price [ref="priceContainer"]');
    if (details.price != null && priceNodes.length) {
      var formatted = formatMoney(details.price);
      Array.prototype.forEach.call(priceNodes, function (node) {
        node.textContent = formatted;
      });
    }
  }

  function updateUrlVariant(variantId) {
    if (!variantId || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function applyConfiguration(colour, finish, options) {
    options = options || {};
    // Keep 2D PDP (gallery / finish radios / ATC) and 3D Tour independent.
    var sync3d = options.sync3d !== false;
    var syncNative = options.syncNative === true;
    var syncCart = options.syncCart === true;

    if (sync3d && !canApply3dChanges()) return;

    var finishInput = getCheckedFinishInput();
    if (!finish) finish = getFinishKey(finishInput);

    if (!colour) {
      var mount = getMount();
      colour = mount ? mount.dataset.currentColour || 'white' : 'white';
    }

    updateMountState(colour, finish);
    update3dColourLabel(colour);
    updateBathtubSwatches(colour, finish);
    updateBathtubPanelLabel(colour, finish);

    // Only mark 3D Tour colour tiles active — never the 2D Material Card tiles.
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-bf-3d-bathtub-colour]'),
      function (tile) {
        var tileColour = tile.getAttribute('data-bf-3d-bathtub-colour');
        var isActive = tileColour === colour;
        tile.classList.toggle('is-active', isActive);
        if (isActive) tile.setAttribute('aria-current', 'true');
        else tile.removeAttribute('aria-current');
      }
    );

    if (syncNative) {
      setActiveColourTile(colour);
      syncNativeFinishSelection(colour, finish);
    }

    if (syncCart) {
      var variantId = resolveVariantId(colour, finish);
      updateVariantInput(variantId);
      updatePriceDisplay(variantId);
      updateUrlVariant(variantId);
    }

    if (
      sync3d &&
      window.BadeloftConfigurator &&
      typeof window.BadeloftConfigurator.setConfiguration === 'function'
    ) {
      window.BadeloftConfigurator.setConfiguration(colour, finish);
    }
  }

  function applySlotPreset(slotId, presetKey, label) {
    if (!canApply3dChanges()) return;
    updateSlotLabel(slotId, label);
    if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.setSlotPreset === 'function') {
      window.BadeloftConfigurator.setSlotPreset(slotId, presetKey);
    }
  }

  function resolveDrainCapPreset(tile) {
    var preset = tile.getAttribute('data-bf-3d-preset');
    if (preset) return preset;
    var title = (tile.getAttribute('data-variant-title') || tile.title || '').toLowerCase().trim();
    return DRAIN_CAP_PRESETS[title] || null;
  }

  function handleDrainCapClick(event) {
    // 2D Material Card drain tiles must not drive the 3D Tour.
    // Only the Tour's own material panel / dock controls 3D drain finish.
    var tile = event.target.closest('[data-bf-3d-slot="drainCap"]');
    if (!tile || !isEventFrom3dTourUi(event) || !canApply3dChanges()) return;

    var preset = resolveDrainCapPreset(tile);
    if (!preset) return;

    var label = tile.getAttribute('data-bf-3d-label') || tile.getAttribute('data-variant-title') || tile.title || '';
    applySlotPreset('drainCap', preset, label);
    syncDrainCapPanel(preset, label);
  }

  function handle3dMaterialClick(event) {
    if (!isEventFrom3dTourUi(event) || !canApply3dChanges()) return;

    var slotBtn = event.target.closest('[data-bf-3d-slot]');
    if (slotBtn) {
      var slotIdEarly = slotBtn.getAttribute('data-bf-3d-slot');
      // Sink panel has its own handler; skip faucet/drainCap/countertop/sink double-apply from bathtub path.
      if (isSinkMount() && (slotIdEarly === 'faucet' || slotIdEarly === 'drainCap' || slotIdEarly === 'countertop' || slotIdEarly === 'sink')) {
        return;
      }
      event.preventDefault();
      setActiveInGroup(slotBtn);
      applySlotPreset(
        slotBtn.getAttribute('data-bf-3d-slot'),
        slotBtn.getAttribute('data-bf-3d-preset'),
        slotBtn.getAttribute('data-bf-3d-label')
      );
      return;
    }

    var colourBtn = event.target.closest('[data-bf-3d-bathtub-colour]');
    if (colourBtn) {
      event.preventDefault();
      setActiveInGroup(colourBtn);
      var mount = getMount();
      var finish = mount ? mount.dataset.currentFinish || 'matte' : 'matte';
      var colour = colourBtn.getAttribute('data-bf-3d-bathtub-colour');
      applyConfiguration(colour, finish, { sync3d: true, syncNative: false, syncCart: false });
      return;
    }

    var finishBtn = event.target.closest('[data-bf-3d-bathtub-finish]');
    if (finishBtn) {
      event.preventDefault();
      setActiveInGroup(finishBtn);
      var mountFinish = getMount();
      var colourFinish = mountFinish ? mountFinish.dataset.currentColour || 'white' : 'white';
      var finishKey = finishBtn.getAttribute('data-bf-3d-bathtub-finish');
      applyConfiguration(colourFinish, finishKey, { sync3d: true, syncNative: false, syncCart: false });
    }
  }

  function sync3dPanelFromMount() {
    var mount = getMount();
    if (!mount) return;
    var colour = mount.dataset.currentColour || 'white';
    var finish = mount.dataset.currentFinish || 'matte';
    update3dColourLabel(colour);
    updateBathtubSwatches(colour, finish);

    var panel = document.querySelector('[data-bf-3d-material-panel]');
    if (!panel) return;

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-bathtub-colour]'), function (tile) {
      var isActive = tile.getAttribute('data-bf-3d-bathtub-colour') === colour;
      tile.classList.toggle('is-active', isActive);
    });

    var colourBtn = panel.querySelector('[data-bf-3d-bathtub-colour="' + colour + '"]');
    if (colourBtn) setActiveInGroup(colourBtn);

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-bathtub-finish]'), function (btn) {
      if (btn.getAttribute('data-bf-3d-bathtub-finish') === finish) {
        setActiveInGroup(btn);
      }
    });
  }

  function isSinkMount(mount) {
    mount = mount || getMount();
    if (!mount) return false;
    if (mount.dataset.productFamily === 'sink') return true;
    var config = getConfig();
    return config && config.productFamily === 'sink';
  }

  function setActiveVisibilityGroup(groupId, stateId) {
    var panel = document.querySelector('[data-bf-3d-sink-panel]');
    if (!panel) return;
    var activeLabel = '';
    Array.prototype.forEach.call(
      panel.querySelectorAll('[data-bf-3d-visibility="' + groupId + '"]'),
      function (btn) {
        var active = btn.getAttribute('data-bf-3d-visibility-state') === stateId;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (active) {
          activeLabel = (btn.textContent || '').trim();
        }
      }
    );
    if (activeLabel) {
      Array.prototype.forEach.call(
        panel.querySelectorAll('[data-bf-3d-visibility-label="' + groupId + '"]'),
        function (node) {
          node.textContent = activeLabel;
        }
      );
    }
  }

  function applyVisibilityGroup(groupId, stateId) {
    if (!canApply3dChanges()) return;
    setActiveVisibilityGroup(groupId, stateId);
    if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.setVisibilityGroup === 'function') {
      window.BadeloftConfigurator.setVisibilityGroup(groupId, stateId);
    }
  }

  function setCameraPresetActive(presetId) {
    var group = document.querySelector('[data-bf-3d-camera-presets]');
    if (!group) return;
    Array.prototype.forEach.call(group.querySelectorAll('[data-bf-3d-camera-preset]'), function (btn) {
      var active = !!presetId && btn.getAttribute('data-bf-3d-camera-preset') === presetId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) {
        var label = btn.getAttribute('data-bf-3d-label') || (btn.textContent || '').trim();
        Array.prototype.forEach.call(
          group.querySelectorAll('[data-bf-3d-camera-label]'),
          function (node) {
            node.textContent = label;
          }
        );
      }
    });
  }

  function applyCameraPreset(presetId) {
    if (!canApply3dChanges()) return;
    setCameraPresetActive(presetId);
    if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.setCameraPreset === 'function') {
      window.BadeloftConfigurator.setCameraPreset(presetId);
    }
  }

  function updateSinkSwatches(colour, finish) {
    var panel = document.querySelector('[data-bf-3d-sink-panel]');
    if (!panel) return;

    var colourLabel = COLOUR_LABELS[colour] || colour;
    var finishLabel = FINISH_LABELS[finish] || 'Matte';

    panel.querySelectorAll('[data-bf-3d-colour-label]').forEach(function (node) {
      node.textContent = colourLabel;
    });
    panel.querySelectorAll('[data-bf-3d-slot-label="sink"]').forEach(function (node) {
      node.textContent = finishLabel;
    });

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-sink-finish]'), function (btn) {
      var key = btn.getAttribute('data-bf-3d-sink-finish');
      var label = FINISH_LABELS[key] || key;
      btn.setAttribute('data-bf-3d-label', label);
      btn.title = label;
      btn.setAttribute('aria-label', label);
    });

    // Sink colour chips use solid CSS colours — only refresh texture tiles when present.
    var swatchSet = BATHTUB_SWATCHES[colour];
    var assetBase = getSwatchAssetBase(panel);
    if (!swatchSet || !assetBase) return;

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-sink-colour]'), function (btn) {
      if (!/url\(/i.test(btn.style.backgroundImage || '')) return;
      var key = btn.getAttribute('data-bf-3d-sink-colour');
      var set = BATHTUB_SWATCHES[key];
      if (!set) return;
      btn.style.backgroundImage = 'url(' + assetBase + set[finish] + ')';
    });

    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-sink-finish]'), function (btn) {
      var key = btn.getAttribute('data-bf-3d-sink-finish');
      if (btn.classList.contains('bf-cfg__3d-tile') && swatchSet[key]) {
        btn.style.backgroundImage = 'url(' + assetBase + swatchSet[key] + ')';
      }
    });
  }

  function setActiveSinkColourFinish(colour, finish) {
    var panel = document.querySelector('[data-bf-3d-sink-panel]');
    if (!panel) return;
    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-sink-colour]'), function (tile) {
      tile.classList.toggle('is-active', tile.getAttribute('data-bf-3d-sink-colour') === colour);
    });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-sink-finish]'), function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-bf-3d-sink-finish') === finish);
    });
    updateSinkSwatches(colour, finish);
  }

  function applySinkColourFinish(colour, finish) {
    if (!canApply3dChanges()) return;
    var mount = getMount();
    if (mount) {
      mount.dataset.currentColour = colour;
      mount.dataset.currentFinish = finish;
    }
    setActiveSinkColourFinish(colour, finish);
    if (window.BadeloftConfigurator && typeof window.BadeloftConfigurator.setConfiguration === 'function') {
      window.BadeloftConfigurator.setConfiguration(colour, finish);
    }
  }

  var sinkFaucetFinishKey = 'chrome';
  var sinkFaucetFinishLabel = 'Chrome';
  var sinkCountertopKey = 'Light_Stone';
  var sinkFaucetStyle = 'none';
  var sinkFaucetStyleLast = 'vanity';
  var sinkVanityOn = false;
  var sinkTailPieceOn = false;
  /** UB-01 / UB-02 / UB-03 / UB-05 / WB-01 / WB-02 / WT-01: when true, drain cap follows faucet color. Default ON. */
  var sinkSyncFaucetDrainCap = true;
  /** ES-WB: when true, drain cap follows basin color. Default ON. Drain never drives basin. */
  var sinkSyncBasinDrainCap = true;
  var sinkBasinFinishKey = 'brushed_steel';
  var sinkBasinFinishLabel = 'Brushed Steel';

  /** Faucet UI preset → drain-cap metal preset (sync is faucet-driven only).
   *  Gold has no drain-cap match — omitted so Gold faucet leaves drain cap unchanged. */
  var FAUCET_TO_DRAIN_CAP = {
    chrome: { preset: 'chrome', label: 'Chrome' },
    brushed_steel: { preset: 'brushed_steel', label: 'Brushed Steel' },
    black: { preset: 'matte_black', label: 'Black' },
    matte_black: { preset: 'matte_black', label: 'Black' },
  };

  /** ES-WB basin finish → drain-cap finish (1:1; basin-driven only). */
  var BASIN_TO_DRAIN_CAP = {
    brushed_steel: { preset: 'brushed_steel', label: 'Brushed Steel' },
    brushed_gold: { preset: 'brushed_gold', label: 'Gold' },
    brushed_rose_gold: { preset: 'brushed_rose_gold', label: 'Rose Gold' },
  };

  function isUb01SinkPanel() {
    return !!document.querySelector('[data-bf-3d-sink-ub01]');
  }

  function isWt01SinkPanel() {
    var mount = getMount();
    if (mount && mount.querySelector('[data-bf-3d-sink-wt01]')) return true;
    return !!document.querySelector('[data-bf-3d-sink-wt01]');
  }

  function isEsWbSinkPanel() {
    var mount = getMount();
    if (mount && mount.querySelector('[data-bf-3d-sink-es-wb01]')) return true;
    return !!document.querySelector('[data-bf-3d-sink-es-wb01]');
  }

  /** UB-01 / UB-02 / UB-03 / UB-05 / WB-01 / WB-02 / WT-01 share faucet ↔ drain-cap sync. */
  function isSyncFaucetDrainPanel() {
    return isUb01SinkPanel() || isWt01SinkPanel();
  }

  function syncDrainCapFromFaucet() {
    if (!sinkSyncFaucetDrainCap || !isSyncFaucetDrainPanel()) return;
    if (!canApply3dChanges()) return;
    var mapped = FAUCET_TO_DRAIN_CAP[sinkFaucetFinishKey];
    if (!mapped) return;
    applySlotPreset('drainCap', mapped.preset, mapped.label);
    syncDrainCapPanel(mapped.preset, mapped.label);
  }

  function syncFaucetDrainCapToggleUi() {
    var mount = getMount();
    var btn = mount && mount.querySelector('[data-bf-3d-sync-faucet-drain]');
    if (btn) {
      btn.setAttribute('aria-checked', sinkSyncFaucetDrainCap ? 'true' : 'false');
      btn.classList.toggle('is-on', !!sinkSyncFaucetDrainCap);
    }
  }

  function setSinkSyncFaucetDrainCap(on) {
    if (!isSyncFaucetDrainPanel()) return;
    if (!canApply3dChanges()) return;
    sinkSyncFaucetDrainCap = !!on;
    syncFaucetDrainCapToggleUi();
    if (sinkSyncFaucetDrainCap) syncDrainCapFromFaucet();
  }

  function syncDrainCapFromBasin() {
    if (!sinkSyncBasinDrainCap || !isEsWbSinkPanel()) return;
    if (!canApply3dChanges()) return;
    var mapped = BASIN_TO_DRAIN_CAP[sinkBasinFinishKey];
    if (!mapped) {
      mapped = {
        preset: sinkBasinFinishKey,
        label: sinkBasinFinishLabel || sinkBasinFinishKey,
      };
    }
    applySlotPreset('drainCap', mapped.preset, mapped.label);
    syncDrainCapPanel(mapped.preset, mapped.label);
  }

  function syncBasinDrainCapToggleUi() {
    var mount = getMount();
    var btn = mount && mount.querySelector('[data-bf-3d-sync-basin-drain]');
    if (btn) {
      btn.setAttribute('aria-checked', sinkSyncBasinDrainCap ? 'true' : 'false');
      btn.classList.toggle('is-on', !!sinkSyncBasinDrainCap);
    }
  }

  function setSinkSyncBasinDrainCap(on) {
    if (!isEsWbSinkPanel()) return;
    if (!canApply3dChanges()) return;
    sinkSyncBasinDrainCap = !!on;
    syncBasinDrainCapToggleUi();
    if (sinkSyncBasinDrainCap) syncDrainCapFromBasin();
  }

  function isVanityOn() {
    return sinkVanityOn;
  }

  function syncTailPieceDisplayUi() {
    var mount = getMount();
    if (!mount) return;
    var displayGroup = mount.querySelector('[data-bf-3d-tailpiece-display]');
    if (!displayGroup) return;
    Array.prototype.forEach.call(displayGroup.querySelectorAll('[data-bf-3d-tailpiece-power]'), function (btn) {
      var on = btn.getAttribute('data-bf-3d-tailpiece-power') === 'on';
      var active = on ? !!sinkTailPieceOn : !sinkTailPieceOn;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function applySinkTailPieceToggle(on) {
    if (!canApply3dChanges()) return;
    sinkTailPieceOn = !!on;
    applyVisibilityGroup('tailPiece', on ? 'on' : 'off');
    syncTailPieceDisplayUi();
  }

  var sceneStyleOpen = false;

  function forEachInMount(mount, selector, fn) {
    if (!mount) return;
    Array.prototype.forEach.call(mount.querySelectorAll(selector), fn);
  }

  function setSceneStyleOpen(open) {
    sceneStyleOpen = !!open;
    var mount = getMount();
    if (!mount || !isSinkMount(mount)) return;
    forEachInMount(mount, '[data-bf-3d-scene-style-panel]', function (panel) {
      panel.hidden = !sceneStyleOpen;
      panel.setAttribute('aria-hidden', sceneStyleOpen ? 'false' : 'true');
    });
    forEachInMount(mount, '[data-bf-3d-scene-style-trigger]', function (trigger) {
      trigger.setAttribute('aria-expanded', sceneStyleOpen ? 'true' : 'false');
      trigger.classList.toggle('is-active', sceneStyleOpen);
    });
    forEachInMount(mount, '[data-bf-3d-scene-style-root]', function (root) {
      root.classList.toggle('is-scene-style-open', sceneStyleOpen);
    });
  }

  function setVanityPanelOpen(open) {
    setSceneStyleOpen(open);
  }

  function setFaucetPanelOpen(open) {
    setSceneStyleOpen(open);
  }

  function syncVanityDisplayUi() {
    var mount = getMount();
    if (!mount) return;
    forEachInMount(mount, '[data-bf-3d-vanity-display]', function (displayGroup) {
      Array.prototype.forEach.call(displayGroup.querySelectorAll('[data-bf-3d-vanity-power]'), function (btn) {
        var on = btn.getAttribute('data-bf-3d-vanity-power') === 'on';
        var active = on ? !!sinkVanityOn : !sinkVanityOn;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
    forEachInMount(mount, '[data-bf-3d-vanity-transparency-row]', function (transparencyRow) {
      transparencyRow.hidden = !sinkVanityOn;
    });
    forEachInMount(mount, '[data-bf-3d-vanity-top-row]', function (topRow) {
      topRow.hidden = !sinkVanityOn;
    });
  }

  function syncFaucetToolbarVisibility() {
    var mount = getMount();
    if (!mount) return;
    var show = !!sinkVanityOn || isWt01SinkPanel();
    forEachInMount(mount, '[data-bf-3d-sink-faucet-card]', function (card) {
      card.hidden = !show;
      card.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  function isSinkFaucetOn() {
    return sinkFaucetStyle === 'wall' || sinkFaucetStyle === 'vanity';
  }

  function syncFaucetPowerUi() {
    var mount = getMount();
    if (!mount) return;
    var on = isSinkFaucetOn();
    forEachInMount(mount, '[data-bf-3d-faucet-power]', function (btn) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function syncFaucetDetailsVisibility() {
    var mount = getMount();
    if (!mount || !isWt01SinkPanel()) return;
    var showDetails = isSinkFaucetOn();
    forEachInMount(mount, '[data-bf-3d-faucet-details]', function (details) {
      details.hidden = !showDetails;
    });
  }

  function applySinkFaucetPower(on) {
    if (!canApply3dChanges()) return;
    if (!isWt01SinkPanel()) return;
    if (on) {
      var next =
        sinkFaucetStyleLast === 'wall' || sinkFaucetStyleLast === 'vanity'
          ? sinkFaucetStyleLast
          : 'vanity';
      applySinkFaucetStyle(next);
    } else {
      if (isSinkFaucetOn()) sinkFaucetStyleLast = sinkFaucetStyle;
      clearAllFaucets();
    }
    syncFaucetPowerUi();
    syncFaucetDetailsVisibility();
  }

  function syncTransparencyWithVanity() {
    if (
      window.BadeloftConfigurator &&
      typeof window.BadeloftConfigurator.syncTransparencyWithVanity === 'function'
    ) {
      window.BadeloftConfigurator.syncTransparencyWithVanity(!!sinkVanityOn);
    }
    syncVanityDisplayUi();
    var mount = getMount();
    if (!mount) return;
    var show = !!sinkVanityOn;
    forEachInMount(mount, '[data-bf-3d-toolbar-transparency]', function (btn) {
      btn.hidden = !show;
      btn.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) {
        btn.setAttribute('aria-checked', 'false');
        btn.classList.remove('is-on');
      }
    });
  }

  function syncVanityStoneUi() {
    var mount = getMount();
    if (!mount) return;
    forEachInMount(mount, '[data-bf-3d-vanity-materials]', function (materials) {
      var active = materials.querySelector('[data-bf-3d-preset="' + sinkCountertopKey + '"]');
      if (active) setActiveInGroup(active);
    });
  }

  function syncFaucetStyleUi(styleId) {
    var mount = getMount();
    if (!mount) return;
    forEachInMount(mount, '[data-bf-3d-faucet-styles]', function (panel) {
      Array.prototype.forEach.call(panel.querySelectorAll('[data-bf-3d-faucet-style]'), function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-bf-3d-faucet-style') === styleId);
      });
    });
  }

  function syncFaucetFinishUi() {
    var mount = getMount();
    if (!mount) return;
    forEachInMount(mount, '[data-bf-3d-faucet-finishes]', function (finishes) {
      var active = finishes.querySelector('[data-bf-3d-preset="' + sinkFaucetFinishKey + '"]');
      if (active) {
        setActiveInGroup(active);
        sinkFaucetFinishLabel =
          active.getAttribute('data-bf-3d-label') || sinkFaucetFinishLabel || sinkFaucetFinishKey;
      }
    });
    updateSlotLabel('faucet', sinkFaucetFinishLabel);
  }

  function clearAllFaucets() {
    sinkFaucetStyle = 'none';
    syncFaucetStyleUi('none');
    applyVisibilityGroup('faucetStyle', 'none');
    syncFaucetPowerUi();
    syncFaucetDetailsVisibility();
  }

  function applySinkVanityToggle(on) {
    if (!canApply3dChanges()) return;
    // WT-01 category has no vanity — ignore vanity power toggles.
    if (isWt01SinkPanel()) {
      sinkVanityOn = false;
      applyVisibilityGroup('vanity', 'off');
      syncFaucetToolbarVisibility();
      return;
    }
    var turningOn = !!on && !sinkVanityOn;
    sinkVanityOn = !!on;

    applyVisibilityGroup('vanity', on ? 'on' : 'off');
    syncTransparencyWithVanity();
    syncFaucetToolbarVisibility();
    syncVanityDisplayUi();
    if (on) {
      applySlotPreset('countertop', sinkCountertopKey, sinkCountertopKey.replace(/_/g, ' '));
      syncVanityStoneUi();
      // Default to vanity faucet only the first time vanity is turned on.
      if (turningOn && sinkFaucetStyle === 'none') {
        sinkFaucetStyle = 'vanity';
      }
      if (sinkFaucetStyle === 'wall' || sinkFaucetStyle === 'vanity') {
        syncFaucetStyleUi(sinkFaucetStyle);
        applySlotPreset('faucet', sinkFaucetFinishKey, sinkFaucetFinishLabel);
        syncFaucetFinishUi();
        applyVisibilityGroup('faucetStyle', sinkFaucetStyle);
        syncDrainCapFromFaucet();
      }
    } else {
      clearAllFaucets();
    }
  }

  function applySinkFaucetStyle(styleId) {
    if (!canApply3dChanges()) return;
    var next = styleId === 'wall' || styleId === 'vanity' ? styleId : 'none';
    if (next === 'none') {
      clearAllFaucets();
      return;
    }

    // WT-01 has no vanity cabinet — allow wall / countertop faucet without enabling vanity.
    if (!isWt01SinkPanel() && !isVanityOn()) {
      applySinkVanityToggle(true);
    }

    sinkFaucetStyle = next;
    if (next === 'wall' || next === 'vanity') sinkFaucetStyleLast = next;
    syncFaucetStyleUi(next);
    applySlotPreset('faucet', sinkFaucetFinishKey, sinkFaucetFinishLabel);
    syncFaucetFinishUi();
    applyVisibilityGroup('faucetStyle', next);
    syncDrainCapFromFaucet();
    syncFaucetPowerUi();
    syncFaucetDetailsVisibility();
  }

  function applySinkFaucetFinish(presetKey, label) {
    if (!canApply3dChanges()) return;
    if (!isWt01SinkPanel() && !isVanityOn()) {
      applySinkVanityToggle(true);
    }

    sinkFaucetFinishKey = presetKey || 'chrome';
    sinkFaucetFinishLabel = label || sinkFaucetFinishKey;
    applySlotPreset('faucet', sinkFaucetFinishKey, sinkFaucetFinishLabel);
    syncFaucetFinishUi();
    if (sinkFaucetStyle === 'none') {
      applySinkFaucetStyle(isWt01SinkPanel() ? 'vanity' : 'vanity');
      syncDrainCapFromFaucet();
      return;
    }
    applyVisibilityGroup('faucetStyle', sinkFaucetStyle);
    syncDrainCapFromFaucet();
  }

  function handleSinkMaterialClick(event) {
    if (!isEventFrom3dTourUi(event) || !canApply3dChanges()) return;

    // Camera presets apply to every family (sinks and bathtubs), so handle them
    // before the sink-only guard below. Restored 2026-08-30: the 3D forward port
    // moved this branch below the guard, which silently killed Angle/Side/Top on
    // bathtubs while leaving the buttons on screen.
    var cameraBtn = event.target.closest('[data-bf-3d-camera-preset]');
    if (cameraBtn) {
      event.preventDefault();
      applyCameraPreset(cameraBtn.getAttribute('data-bf-3d-camera-preset'));
      return;
    }

    if (!isSinkMount()) return;

    var syncToggle = event.target.closest('[data-bf-3d-sync-faucet-drain]');
    if (syncToggle) {
      event.preventDefault();
      event.stopPropagation();
      var next =
        syncToggle.getAttribute('aria-checked') !== 'true' &&
        !syncToggle.classList.contains('is-on');
      setSinkSyncFaucetDrainCap(next);
      return;
    }

    var sceneStyleTrigger = event.target.closest('[data-bf-3d-scene-style-trigger]');
    if (sceneStyleTrigger) {
      event.preventDefault();
      event.stopPropagation();
      setSceneStyleOpen(!sceneStyleOpen);
      return;
    }

    var basinDrainSyncToggle = event.target.closest('[data-bf-3d-sync-basin-drain]');
    if (basinDrainSyncToggle) {
      event.preventDefault();
      event.stopPropagation();
      var nextBasinSync =
        basinDrainSyncToggle.getAttribute('aria-checked') !== 'true' &&
        !basinDrainSyncToggle.classList.contains('is-on');
      setSinkSyncBasinDrainCap(nextBasinSync);
      return;
    }

    var vanityPower = event.target.closest('[data-bf-3d-vanity-power]');
    if (vanityPower) {
      event.preventDefault();
      event.stopPropagation();
      applySinkVanityToggle(vanityPower.getAttribute('data-bf-3d-vanity-power') === 'on');
      return;
    }

    var tailPiecePower = event.target.closest('[data-bf-3d-tailpiece-power]');
    if (tailPiecePower) {
      event.preventDefault();
      event.stopPropagation();
      applySinkTailPieceToggle(tailPiecePower.getAttribute('data-bf-3d-tailpiece-power') === 'on');
      return;
    }

    var faucetPower = event.target.closest('[data-bf-3d-faucet-power]');
    if (faucetPower) {
      event.preventDefault();
      event.stopPropagation();
      var nextFaucet =
        faucetPower.getAttribute('aria-checked') !== 'true' &&
        !faucetPower.classList.contains('is-on');
      applySinkFaucetPower(nextFaucet);
      return;
    }

    var faucetStyleBtn = event.target.closest('[data-bf-3d-faucet-style]');
    if (faucetStyleBtn) {
      event.preventDefault();
      event.stopPropagation();
      applySinkFaucetStyle(faucetStyleBtn.getAttribute('data-bf-3d-faucet-style'));
      return;
    }

    var sinkColourBtn = event.target.closest('[data-bf-3d-sink-colour]');
    if (sinkColourBtn) {
      event.preventDefault();
      var mount = getMount();
      var finish = (mount && mount.dataset.currentFinish) || 'matte';
      applySinkColourFinish(sinkColourBtn.getAttribute('data-bf-3d-sink-colour'), finish);
      return;
    }

    var sinkFinishBtn = event.target.closest('[data-bf-3d-sink-finish]');
    if (sinkFinishBtn) {
      event.preventDefault();
      var mountFinish = getMount();
      var colour = (mountFinish && mountFinish.dataset.currentColour) || 'white';
      applySinkColourFinish(colour, sinkFinishBtn.getAttribute('data-bf-3d-sink-finish'));
      return;
    }

    var faucetBtn = event.target.closest('[data-bf-3d-slot="faucet"]');
    if (faucetBtn) {
      event.preventDefault();
      setActiveInGroup(faucetBtn);
      applySinkFaucetFinish(
        faucetBtn.getAttribute('data-bf-3d-preset'),
        faucetBtn.getAttribute('data-bf-3d-label')
      );
      return;
    }

    var slotBtn = event.target.closest('[data-bf-3d-slot]');
    if (slotBtn) {
      event.preventDefault();
      setActiveInGroup(slotBtn);
      var slotId = slotBtn.getAttribute('data-bf-3d-slot');
      var preset = slotBtn.getAttribute('data-bf-3d-preset');
      var label = slotBtn.getAttribute('data-bf-3d-label');
      if (slotId === 'countertop' && preset) {
        sinkCountertopKey = preset;
        if (!isVanityOn()) applySinkVanityToggle(true);
        else {
          applySlotPreset(slotId, preset, label);
          syncVanityStoneUi();
        }
        return;
      }
      // ES-WB: basin → drain sync (drain never drives basin).
      if (slotId === 'sink' && isEsWbSinkPanel() && preset) {
        sinkBasinFinishKey = preset;
        sinkBasinFinishLabel = label || sinkBasinFinishKey;
        applySlotPreset(slotId, preset, label);
        syncDrainCapFromBasin();
        return;
      }
      applySlotPreset(slotId, preset, label);
    }
  }

  function handleToolbarPanelOutsideClick(event) {
    if (!sceneStyleOpen) return;
    var mount = getMount();
    if (!mount || !isSinkMount(mount)) return;
    if (event.target.closest('[data-bf-3d-scene-style-panel]')) return;
    if (event.target.closest('[data-bf-3d-scene-style-trigger]')) return;
    setSceneStyleOpen(false);
  }

  function handleSceneStyleEscape(event) {
    if (event.key !== 'Escape' || !sceneStyleOpen) return;
    setSceneStyleOpen(false);
  }

  function watchSceneStyleOverlayClose() {
    var mount = getMount();
    if (!mount || mount.__bfSceneStyleObserver) return;
    var observer = new MutationObserver(function () {
      if (
        mount.classList.contains('bf-3d-hotspot-popup-open') ||
        mount.classList.contains('bf-3d-hotspot-popup-closing') ||
        mount.classList.contains('bf-3d-measurements-active')
      ) {
        setSceneStyleOpen(false);
      }
    });
    observer.observe(mount, { attributes: true, attributeFilter: ['class'] });
    mount.__bfSceneStyleObserver = observer;
  }

  function handleTourNavClick(event) {
    if (!canApply3dChanges()) return;
    var mount = getMount();
    if (!mount || !isSinkMount(mount)) return;

    if (event.target.closest('[data-bf-3d-tour-prev]')) {
      event.preventDefault();
      window.BadeloftConfigurator?.prevTourStep?.();
    }
    if (event.target.closest('[data-bf-3d-tour-next]')) {
      event.preventDefault();
      window.BadeloftConfigurator?.nextTourStep?.();
    }
  }

  document.addEventListener('click', handleSinkMaterialClick, true);
  document.addEventListener('click', handleToolbarPanelOutsideClick, true);
  document.addEventListener('click', handleTourNavClick, true);
  document.addEventListener('keydown', handleSceneStyleEscape, true);
  document.addEventListener('bf3d:camera-user-change', function () {
    setCameraPresetActive(null);
  });

  document.addEventListener('click', handle3dMaterialClick, true);
  document.addEventListener('click', handleDrainCapClick, true);

  // Note: no variant:update → 3D sync. 2D Material Card / gallery stay independent of Tour.

  function syncFromReadyMount() {
    if (!is3dActive()) return;
    var mount = getMount();
    if (!mount || !mount.classList.contains('is-ready')) return;
    if (!canApply3dChanges()) return;
    if (isSinkMount(mount)) {
      var colour = mount.dataset.currentColour || 'white';
      var config = getConfig();
      var finish =
        (config && config.defaultFinish) ||
        mount.dataset.currentFinish ||
        'matte';
      if (finish !== 'matte' && finish !== 'glossy') finish = 'matte';
      mount.dataset.currentColour = colour;
      mount.dataset.currentFinish = finish;
      setActiveSinkColourFinish(colour, finish);
      // Default OFF on all sinks unless config explicitly sets defaultVisibility.tailPiece true.
      var tailPieceDefault = !!(config && config.defaultVisibility && config.defaultVisibility.tailPiece === true);
      sinkTailPieceOn = tailPieceDefault;
      applyVisibilityGroup('tailPiece', tailPieceDefault ? 'on' : 'off');
      syncTailPieceDisplayUi();
      sinkVanityOn = false;
      sinkFaucetStyle = 'none';
      sinkSyncFaucetDrainCap = true;
      sinkSyncBasinDrainCap = true;
      if (isEsWbSinkPanel()) {
        sinkBasinFinishKey = 'brushed_steel';
        sinkBasinFinishLabel = 'Brushed Steel';
        syncBasinDrainCapToggleUi();
        syncDrainCapFromBasin();
      }
      if (isWt01SinkPanel()) {
        sinkVanityOn = false;
        applyVisibilityGroup('vanity', 'off');
        // Default OFF unless config explicitly sets wall/vanity.
        var faucetDefault =
          (config && config.defaultVisibility && config.defaultVisibility.faucetStyle) || 'none';
        if (faucetDefault === 'wall' || faucetDefault === 'vanity') {
          sinkFaucetStyleLast = faucetDefault;
          sinkFaucetStyle = faucetDefault;
          syncFaucetDrainCapToggleUi();
          syncFaucetStyleUi(sinkFaucetStyle);
          applySlotPreset('faucet', sinkFaucetFinishKey, sinkFaucetFinishLabel);
          syncFaucetFinishUi();
          applyVisibilityGroup('faucetStyle', sinkFaucetStyle);
          syncDrainCapFromFaucet();
        } else {
          sinkFaucetStyle = 'none';
          syncFaucetDrainCapToggleUi();
          syncFaucetStyleUi('none');
          syncFaucetFinishUi();
          applyVisibilityGroup('faucetStyle', 'none');
        }
        syncFaucetPowerUi();
        syncFaucetDetailsVisibility();
        syncFaucetToolbarVisibility();
        setCameraPresetActive(null);
        return;
      }
      syncFaucetDrainCapToggleUi();
      syncDrainCapFromFaucet();
      syncFaucetStyleUi('none');
      syncFaucetFinishUi();
      syncVanityStoneUi();
      syncVanityDisplayUi();
      syncFaucetToolbarVisibility();
      syncTransparencyWithVanity();
      setCameraPresetActive(null);
      return;
    }
    // Seed Tour materials from its own mount dataset only — do not pull from 2D finish radios.
    applyConfiguration(mount.dataset.currentColour, mount.dataset.currentFinish, {
      sync3d: true,
      syncNative: false,
      syncCart: false,
    });
    sync3dPanelFromMount();
  }

  document.addEventListener('bf3d:ready', function () {
    syncFromReadyMount();
    watchSceneStyleOverlayClose();
  });

  function syncMobileStickyTop() {
    var mq = window.matchMedia('(max-width: 768px)');
    if (!mq.matches) {
      document.documentElement.style.removeProperty('--bf-3d-mobile-sticky-top');
      return 0;
    }
    var header = 0;
    try {
      header = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    } catch (error) {
      header = 0;
    }
    var navwrap = document.querySelector('.bf-tabs__navwrap');
    var navH = navwrap && navwrap.offsetHeight ? navwrap.offsetHeight : 0;
    var top = header + navH;
    document.documentElement.style.setProperty('--bf-3d-mobile-sticky-top', top + 'px');
    return top;
  }

  function getStickyEndTarget(mount) {
    var end = mount.querySelector('[data-bf-3d-sticky-end]');
    if (end) return end;
    var dock = mount.querySelector('[data-bf-3d-sticky-dock], .bf-3d-configurator__dock');
    if (!dock) return null;
    var controls = dock.querySelectorAll(
      'button, [data-bf-3d-scene-style-trigger], .bf-sink-options__section, .bf-cfg__section, .bf-scene-style--sidebar'
    );
    if (controls.length) return controls[controls.length - 1];
    return dock.lastElementChild || dock;
  }

  function updateMobileStickyRelease(mount) {
    if (!mount || !mount.classList.contains('bf-3d-configurator--with-dock')) return;
    var mq = window.matchMedia('(max-width: 768px)');
    if (!mq.matches) {
      mount.classList.remove('is-mobile-sticky-released');
      return;
    }
    if (
      mount.classList.contains('bf-3d-hotspot-popup-open') ||
      mount.classList.contains('bf-3d-hotspot-popup-closing') ||
      mount.classList.contains('bf-3d-measurements-active')
    ) {
      mount.classList.remove('is-mobile-sticky-released');
      return;
    }

    var stage = mount.querySelector('[data-bf-3d-sticky-stage], .bf-3d-configurator__stage');
    var endTarget = getStickyEndTarget(mount);
    if (!stage || !endTarget) {
      mount.classList.remove('is-mobile-sticky-released');
      return;
    }

    var stickyTop = syncMobileStickyTop();
    var stageRect = stage.getBoundingClientRect();
    var endRect = endTarget.getBoundingClientRect();

    // Last control / end sentinel has scrolled fully past the sticky stage bottom.
    var pastStickyBottom = endRect.bottom < stageRect.bottom;

    // Avoid jump: only flip to static once sticky has already started releasing
    // (stage top moved above the sticky offset) OR the stage is still at its
    // in-flow position (not stuck yet). While truly stuck, keep position:sticky
    // so the stage scrolls away continuously with the parent.
    var stuckEpsilon = 2;
    var isStuck = Math.abs(stageRect.top - stickyTop) <= stuckEpsilon;
    var alreadyScrollingAway = stageRect.top < stickyTop - stuckEpsilon;

    if (pastStickyBottom && (alreadyScrollingAway || !isStuck)) {
      mount.classList.add('is-mobile-sticky-released');
    } else if (!pastStickyBottom) {
      mount.classList.remove('is-mobile-sticky-released');
    }
  }

  var mobileStickyWatchStarted = false;

  function watchMobileStickyStages() {
    if (mobileStickyWatchStarted) {
      syncMobileStickyTop();
      var existing = document.querySelectorAll('[data-bf-3d-configurator].bf-3d-configurator--with-dock');
      for (var e = 0; e < existing.length; e++) updateMobileStickyRelease(existing[e]);
      return;
    }
    mobileStickyWatchStarted = true;

    var mq = window.matchMedia('(max-width: 768px)');
    var mounts = document.querySelectorAll('[data-bf-3d-configurator].bf-3d-configurator--with-dock');
    if (!mounts.length) {
      mobileStickyWatchStarted = false;
      return;
    }

    var scheduled = false;
    function tick() {
      scheduled = false;
      syncMobileStickyTop();
      mounts = document.querySelectorAll('[data-bf-3d-configurator].bf-3d-configurator--with-dock');
      for (var i = 0; i < mounts.length; i++) {
        updateMobileStickyRelease(mounts[i]);
      }
    }
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(tick);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else if (mq.addListener) mq.addListener(schedule);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function () {
        schedule();
      }, {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.01, 1],
      });
      for (var j = 0; j < mounts.length; j++) {
        var endTarget = getStickyEndTarget(mounts[j]);
        var stage = mounts[j].querySelector('[data-bf-3d-sticky-stage], .bf-3d-configurator__stage');
        if (endTarget) observer.observe(endTarget);
        if (stage) observer.observe(stage);
      }
    }

    if ('MutationObserver' in window) {
      for (var k = 0; k < mounts.length; k++) {
        (function (mount) {
          var mo = new MutationObserver(schedule);
          mo.observe(mount, { attributes: true, attributeFilter: ['class'] });
        })(mounts[k]);
      }
    }

    tick();
  }

  window.addEventListener('resize', syncMobileStickyTop, { passive: true });
  window.addEventListener('orientationchange', syncMobileStickyTop, { passive: true });
  if (window.matchMedia('(max-width: 768px)').addEventListener) {
    window.matchMedia('(max-width: 768px)').addEventListener('change', syncMobileStickyTop);
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncMobileStickyTop();
    watchMobileStickyStages();
    syncFromReadyMount();
    watchSceneStyleOverlayClose();
  });

  document.addEventListener('bf3d:ready', function () {
    syncMobileStickyTop();
    watchMobileStickyStages();
  });
})();
